/* Pack It Smarter homepage: scroll films, 3D tilt, hero parallax (from the approved v3l prototype). */

/* Scroll-film engine (from the approved prototype). In Shopify: assets/scroll-film.js, loaded defer,
   config read from data-* attributes rendered by sections/scroll-film.liquid. */
(function(){
  'use strict';
  var MEDIA = '';
  var VH_PER_SEC = 20; /* v2: ~17% shorter scroll than the prototype */
  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduced) root.classList.add('rm');

  var mq = window.matchMedia('(max-width: 600px), (orientation: portrait) and (max-aspect-ratio: 2/3)')  /* phones only; tablets in portrait get the 16:9 frames (30.09) */;
  function currentMode(){ return mq.matches ? 'm' : 'd'; }
  var mode = currentMode();
  function frameUrl(id, i, base){ return (base || MEDIA) + id + '-' + mode + '-' + String(i + 1).padStart(4, '0') + '.webp'; }

  /* posters: in Liquid these src/srcset are rendered server-side; here we resolve the local path */
  Array.prototype.forEach.call(document.querySelectorAll('.film__poster [data-src]'), function(el){
    var u = (el.closest('.film').dataset.base || MEDIA) + el.getAttribute('data-src');
    if(el.tagName === 'SOURCE') el.srcset = u; else el.src = u;
  });

  var queue = [], active = 0, MAX_ACTIVE = 6;
  function pump(){
    while(active < MAX_ACTIVE && queue.length){
      var job = queue.shift();
      if(job.f.mode !== mode || job.f.imgs[job.i]) continue;
      active++;
      (function(job){
        var img = new Image(), arr = job.f.imgs;
        img.decoding = 'async';
        arr[job.i] = img;
        function stale(){ return arr !== job.f.imgs; }
        img.onload = function(){ active--; if(!stale()){ job.f.loaded++; job.f.onLoaded(job.i); } pump(); };
        img.onerror = function(){ active--; if(!stale()){ arr[job.i] = null; job.f.failed++; job.f.onLoaded(job.i); } pump(); };
        img.src = frameUrl(job.f.id, job.i, job.f.base);
      })(job);
    }
  }
  function coarseToFine(n){
    var seen = new Uint8Array(n), out = [];
    [8,4,2,1].forEach(function(step){ for(var i = 0; i < n; i += step){ if(!seen[i]){ seen[i] = 1; out.push(i); } } });
    if(!seen[n-1]) out.push(n-1);
    return out;
  }

  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var films = Array.prototype.map.call(document.querySelectorAll('.film[data-film]'), function(sec){
    var cfg = { count:+sec.dataset.count, dur:+sec.dataset.dur, fit:sec.dataset.fit, still:+sec.dataset.still };
    var f = {
      id:sec.dataset.film, base:sec.dataset.base, cfg:cfg, sec:sec, n:cfg.count,
      stage:sec.querySelector('.film__stage'), canvas:sec.querySelector('canvas'), bar:sec.querySelector('.film__load'),
      imgs:[], loaded:0, failed:0, requested:false, mode:null, target:0, shown:0, drawn:-1, near:false, progress:0
    };
    f.ctx = f.canvas.getContext('2d', {alpha:false});
    f.onLoaded = function(i){
      f.bar.firstElementChild.style.width = Math.round((f.loaded + f.failed) / f.n * 100) + '%';
      if(f.loaded + f.failed >= f.n) f.bar.classList.add('done');
      var want = Math.round(f.shown);
      if(f.drawn === -1 || Math.abs(i - want) < Math.abs(f.drawn - want)) draw(f, true);
    };
    var vhps = parseFloat(sec.dataset.vhps) || VH_PER_SEC;
    if(!reduced) sec.style.height = 'calc(' + (100 + cfg.dur * vhps).toFixed(0) + 'vh)';
    f.nav = sec.querySelector('.film__nav');
    return f;
  });

  function resetFilm(f){
    f.imgs = new Array(f.n); f.loaded = 0; f.failed = 0; f.requested = false; f.mode = mode; f.drawn = -1;
    f.stage.classList.remove('drawn');
    f.bar.classList.remove('done'); f.bar.firstElementChild.style.width = '0%';
  }
  function requestPoster(f){ queue.unshift({f:f, i: reduced ? Math.round((f.n - 1) * f.cfg.still) : 0}); }
  /* slow or data-saving connections get every 2nd frame (the engine draws the nearest loaded frame) */
  var conn = navigator.connection || {}, lite = !!conn.saveData || /(^|-)(2g|3g)/.test(conn.effectiveType || '');
  function requestCoarse(f){ if(reduced || f.requested) return; for(var i = 0; i < f.n; i += 8) queue.push({f:f, i:i}); pump(); }
  function requestAll(f){
    if(f.requested || reduced) return;
    f.requested = true;
    coarseToFine(f.n).forEach(function(i){ if(!lite || i % 2 === 0 || i === f.n - 1) queue.push({f:f, i:i}); });
    pump();
  }

  function sizeCanvas(f){
    var W = Math.round(f.canvas.clientWidth * dpr), H = Math.round(f.canvas.clientHeight * dpr);
    if(f.canvas.width !== W || f.canvas.height !== H){ f.canvas.width = W; f.canvas.height = H; f.drawn = -1; }
  }
  function nearestLoaded(f, i){
    for(var d = 0; d < f.n; d++){
      var a = f.imgs[i - d], b = f.imgs[i + d];
      if(a && a.complete && a.naturalWidth) return i - d;
      if(b && b.complete && b.naturalWidth) return i + d;
    }
    return -1;
  }
  function draw(f, force){
    var want = reduced ? Math.round((f.n - 1) * f.cfg.still) : Math.max(0, Math.min(f.n - 1, Math.round(f.shown)));
    var idx = nearestLoaded(f, want);
    if(idx < 0 || (idx === f.drawn && !force)) return;
    var img = f.imgs[idx], c = f.canvas, ctx = f.ctx;
    var cw = c.width, ch = c.height, ir = img.naturalWidth / img.naturalHeight, cr = cw / ch, dw, dh;
    var cover = f.cfg.fit === 'cover' && Math.min(cr, ir) / Math.max(cr, ir) > 0.75;  /* never crop more than a quarter: letterbox instead */
    if((cr > ir) === cover){ dw = cw; dh = cw / ir; } else { dh = ch; dw = ch * ir; }
    ctx.fillStyle = '#000'; ctx.fillRect(0, 0, cw, ch);
    ctx.drawImage(img, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
    f.drawn = idx;
    if(!f.stage.classList.contains('drawn')) f.stage.classList.add('drawn');
  }

  var heroTxt = document.getElementById('heroTxt');
  var sbar = document.getElementById('sbar'), buy = document.getElementById('buy');
  if(!sbar || !buy){ sbar = {classList:{toggle:function(){}}}; buy = document.body; }
  function progressOf(f){
    var r = f.sec.getBoundingClientRect(), total = f.sec.offsetHeight - f.stage.offsetHeight;
    return total > 0 ? Math.max(0, Math.min(1, -r.top / total)) : 0;
  }
  function onScroll(){
    var vh = window.innerHeight;
    for(var k = 0; k < films.length; k++){
      var f = films[k], r = f.sec.getBoundingClientRect();
      f.near = r.bottom > -vh * 0.5 && r.top < vh * 1.5;
      if(reduced) continue;
      f.progress = progressOf(f);
      f.target = f.progress * (f.n - 1);
      /* feather the stage edges while it enters / leaves, so the film grows out of the dark band */
      var fsr = f.stage.getBoundingClientRect();
      f.stage.style.setProperty('--ft', Math.max(0, Math.min(1, fsr.top / (vh * 0.35))).toFixed(3));
      f.stage.style.setProperty('--fb', Math.max(0, Math.min(1, (vh - fsr.bottom) / (vh * 0.35))).toFixed(3));
      if(f.nav){
        /* keep the control on the visible part of the stage (the header pushes the first stage down) */
        var sr = f.stage.getBoundingClientRect();
        f.stage.style.setProperty('--off', Math.max(0, Math.round(sr.bottom - vh)) + 'px');
        f.nav.style.setProperty('--p', f.progress.toFixed(4));
        f.nav.classList.toggle('idle', f.progress < 0.015);
        f.nav.classList.toggle('on', (f.sec.classList.contains('hero') || f.progress > 0.02) && f.progress < 0.93);
      }
    }
    /* hero H1 fades out over the first 12% of the opening film (fully visible without JS) */
    if(heroTxt && !reduced){
      var o = Math.max(0, 1 - films[0].progress / 0.12);
      heroTxt.style.opacity = o.toFixed(3);
      heroTxt.style.transform = 'translateY(' + ((1 - o) * -24).toFixed(1) + 'px)';
      heroTxt.style.visibility = o < 0.01 ? 'hidden' : 'visible';
    }
    /* sticky buy bar: after the hero film, hidden while the buy section is on screen */
    var br = buy.getBoundingClientRect();
    var show = films[0].sec.getBoundingClientRect().bottom < 0 && !(br.top < vh && br.bottom > 0);
    sbar.classList.toggle('on', show);
    kick();
  }

  var raf = null, EASE = 0.18;
  function loop(){
    raf = null;
    var busy = false;
    for(var k = 0; k < films.length; k++){
      var f = films[k];
      if(!f.near) continue;
      var d = f.target - f.shown;
      if(Math.abs(d) < 0.05) f.shown = f.target; else { f.shown += d * EASE; busy = true; }
      draw(f, false);
    }
    if(busy) kick();
  }
  function kick(){ if(raf === null) raf = requestAnimationFrame(loop); }

  function initMode(){
    films.forEach(function(f){ resetFilm(f); requestPoster(f); });
    pump();
    if(!reduced) requestCoarse(films[0]);  /* page load: poster + every 8th frame only */
    films.forEach(function(f){ if(f.nearLoad) requestAll(f); });
  }
  films.forEach(sizeCanvas);
  initMode();

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var f = films.filter(function(x){ return x.sec === e.target; })[0];
        f.nearLoad = e.isIntersecting;
        if(e.isIntersecting) requestAll(f);
      });
    }, {rootMargin:'80% 0px 80% 0px'});
    films.forEach(function(f){ io.observe(f.sec); });
  } else { films.forEach(requestAll); }

  window.addEventListener('scroll', onScroll, {passive:true});
  /* the rest of the opening film loads once the visitor starts scrolling */
  window.addEventListener('scroll', function first(){ window.removeEventListener('scroll', first); requestAll(films[0]); }, {passive:true});
  var rt = null;
  window.addEventListener('resize', function(){
    clearTimeout(rt);
    rt = setTimeout(function(){
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      var m = currentMode();
      if(m !== mode){ mode = m; queue.length = 0; initMode(); }
      films.forEach(function(f){ sizeCanvas(f); draw(f, true); });
      onScroll();
    }, 120);
  }, {passive:true});

  /* skip links: explicit scroll (plain #hash jumps proved unreliable next to pinned stages) */
  Array.prototype.forEach.call(document.querySelectorAll('.film__skip'), function(a){
    a.addEventListener('click', function(e){
      var t = document.querySelector(a.getAttribute('href'));
      if(!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({top:y, behavior: reduced ? 'auto' : 'smooth'});
      setTimeout(function(){ if(Math.abs(t.getBoundingClientRect().top) > 40) window.scrollTo({top: t.getBoundingClientRect().top + window.pageYOffset, behavior:'instant'}); }, 900);
      if(history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
    });
  });

  onScroll();
  films.forEach(function(f){ f.shown = f.target; });
})();


/* 3D tilt: product stages and every tile. Pointer devices only; reduced motion keeps everything still. */
(function(){
  if(!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var tiles = '.card, .var, .grp, .loox, .buy__media, .trust li, .faqx details, .faq details, .mini img, .sbvs__bottom';
  Array.prototype.forEach.call(document.querySelectorAll(tiles), function(el){ if(!el.dataset.tilt) el.dataset.tilt = '7'; });
  Array.prototype.forEach.call(document.querySelectorAll('[data-tilt]'), function(el){
    var max = parseFloat(el.dataset.tilt) || 7, scale = el.dataset.tiltScale || '1.03', raf = 0;
    var stage = el.classList.contains('s3d__tilt');
    el.addEventListener('pointerenter', function(){ el.classList.add('tilting'); });
    el.addEventListener('pointermove', function(e){
      var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){
        var rx = (-y * max).toFixed(2), ry = (x * max).toFixed(2);
        el.style.transform = stage ? 'rotateY(' + ry + 'deg) rotateX(' + rx + 'deg)'
                                   : 'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(' + scale + ')';
      });
    });
    el.addEventListener('pointerleave', function(){ cancelAnimationFrame(raf); el.classList.remove('tilting'); el.style.transform = ''; });
  });
})();


/* v3h hero depth parallax: numbers < mountain+flags < boulder+fridge (pointer devices); gentle drift on touch */
(function(){
  var sc=document.querySelector('.shero .jscn'); if(!sc) return;
  var L=[['.j1',6],['.j2',14],['.j3',26]].map(function(x){return [sc.querySelector(x[0]),x[1]];});
  function set(nx,ny){L.forEach(function(l){ l[0].style.transform='translate('+(nx*l[1]).toFixed(1)+'px,'+(ny*l[1]*.6).toFixed(1)+'px)'; });}
  if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var hero=sc.closest('.shero');
  if(matchMedia('(hover: hover) and (pointer: fine)').matches){
    hero.addEventListener('pointermove',function(e){var r=hero.getBoundingClientRect(); set((e.clientX-r.left)/r.width-.5,(e.clientY-r.top)/r.height-.5);});
    hero.addEventListener('pointerleave',function(){set(0,0);});
  } else {
    var t0=performance.now(), on=true;
    new IntersectionObserver(function(en){on=en[0].isIntersecting;}).observe(hero);
    (function tick(t){ if(on){ var k=(t-t0)/4200; set(Math.sin(k)*.35,Math.cos(k*.8)*.25); } requestAnimationFrame(tick); })(t0);
  }
})();
